var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:[_vm.$style.socialLinks, 'column']},_vm._l((_vm.socialLinks),function(link,index){return _c('li',{key:index},[_c('a',{attrs:{"href":link.url,"target":link.newWindow ? '_blank' : '_self',"title":link.label}},[_c('i',{class:[link.icon, _vm.$style.iconContainer],style:({
          background: link.color
        })})])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }